import {types} from './types';

const initialState = {
    list: [],
}

export function searchUsersReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_SEARCH_USERS_LIST:
            return { ...state, list: action.payload};
        default:
            return state
    }
}